import { IProductResponse } from 'models/product'
import { fromEndDateField } from 'shared/utils/endDate'

export const getCreateCollectionSubmitData = (data: any): any => {
  return {
    title: data.title,
    desc: data.desc,
    status: data.status,
    is_thematic: data.is_thematic,
    fixed_position: !!data.fixed_position,
    end_date: fromEndDateField(data.end_date),
    products: data.products.map((product: IProductResponse) => product._id),
    icon: data.is_thematic ? data.icon.file.originFileObj : undefined,
    photo: data.photo[0].originFileObj
  }
}

export const getEditCollectionSubmitData = (data: any): any => {
  return {
    title: data.title,
    desc: data.desc,
    status: data.status,
    products: data.products.map((product: IProductResponse) => product._id),
    is_thematic: data.is_thematic,
    fixed_position: !!data.fixed_position,
    end_date: fromEndDateField(data.end_date),
    icon: data.is_thematic ? data?.icon?.file?.originFileObj ?? data?.icon?.name : undefined,
    photo: data?.photo?.[0]?.originFileObj ?? data?.photo?.[0]?.uid
  }
}
